import { SvgIcon, SvgIconProps } from '@mui/material'

export function SettingTwoIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.126 1.639a.75.75 0 0 1 .868.382 2.25 2.25 0 0 0 4.012 0 .75.75 0 0 1 .868-.382 10.733 10.733 0 0 1 4.444 2.487.75.75 0 0 1 .162.88A2.25 2.25 0 0 0 21.5 8.25h.031a.75.75 0 0 1 .727.526 10.8 10.8 0 0 1 .274 5.39.75.75 0 0 1-.808.596 2.25 2.25 0 0 0-1.944 3.689.75.75 0 0 1-.034 1.003 10.748 10.748 0 0 1-4.674 2.851.75.75 0 0 1-.928-.49 2.251 2.251 0 0 0-4.288 0 .75.75 0 0 1-.928.49 10.747 10.747 0 0 1-4.674-2.85.75.75 0 0 1-.033-1.004 2.25 2.25 0 0 0-1.944-3.689.75.75 0 0 1-.809-.596 10.795 10.795 0 0 1 .274-5.39.75.75 0 0 1 .727-.525H2.5a2.25 2.25 0 0 0 2.02-3.243.75.75 0 0 1 .162-.881 10.734 10.734 0 0 1 4.444-2.487Zm-3.043 3.25a3.75 3.75 0 0 1-3.048 4.822 9.27 9.27 0 0 0-.2 3.554 3.75 3.75 0 0 1 2.935 5.572 9.249 9.249 0 0 0 2.964 1.82A3.748 3.748 0 0 1 12 18.75c1.402 0 2.623.769 3.266 1.907a9.25 9.25 0 0 0 2.964-1.82 3.75 3.75 0 0 1 2.934-5.572 9.332 9.332 0 0 0-.199-3.553 3.75 3.75 0 0 1-3.048-4.822 9.233 9.233 0 0 0-2.915-1.642A3.744 3.744 0 0 1 12 4.75a3.744 3.744 0 0 1-3.002-1.502A9.234 9.234 0 0 0 6.083 4.89Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.75 12a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0ZM12 9.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default SettingTwoIcon
